// src/components/DownloadExcel.js
import * as XLSX from 'xlsx';

export const downloadExcel = (data, fileName = 'data.xlsx') => {
  // 필드 매핑
  const fields = {
    scan_total_time: '스캔일시',
    barcode: '운송장번호',
    tm_dv: '업무구분',
    car_num: '차량번호',
    bran_cd: '지점코드',
    pob: '지점사원',
    tg_bran_cd: '상대지점',
    emp_cd: '상대영업사원코드',
    dev_serial: 'PDA S/N',
  };

  // 필드 선택 및 별칭 적용
  const formattedData = data.map(item => {
    const newItem = {};
    Object.keys(fields).forEach(key => {
      newItem[fields[key]] = item[key];
    });
    return newItem;
  });

  // 엑셀 시트 생성
  const ws = XLSX.utils.json_to_sheet(formattedData);

  // 열 너비 자동 조정
  const maxColumnWidths = {};
  formattedData.forEach(row => {
    Object.keys(row).forEach((key, i) => {
      const colIndex = XLSX.utils.encode_col(i);
      const cellValue = String(row[key]);
      maxColumnWidths[colIndex] = Math.max(
        (maxColumnWidths[colIndex] || 13), // 기본 너비 10
        cellValue.length
      );
    });
  });

  ws['!cols'] = Object.keys(maxColumnWidths).map(colIndex => ({
    wpx: maxColumnWidths[colIndex] * 7,
  }));

  // 엑셀 파일 생성 및 다운로드
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, fileName);
};
